import { render, staticRenderFns } from "./CandidateAvatar.vue?vue&type=template&id=ce9f2ea2&scoped=true"
import script from "./CandidateAvatar.vue?vue&type=script&lang=js"
export * from "./CandidateAvatar.vue?vue&type=script&lang=js"
import style0 from "./CandidateAvatar.vue?vue&type=style&index=0&id=ce9f2ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9f2ea2",
  null
  
)

export default component.exports